import fetchClient, { ApiResponse } from '@/api/api-client'

import { Affiliate, AffUserData } from './types/Affiliate'
import { AffLink } from './types/AffLink'
import { Coupon } from './types/Coupon'
import { UpdateAffiliatePayload } from './types/UpdateAffiliatePayload'

export async function getAffUserByRefNum(refNum: string) {
  try {
    const res = await fetchClient.get<ApiResponse<Affiliate>>(`affiliate/${refNum}`)
    return res.data.data
  } catch (err) {
    throw err
  }
}

export async function listAffiliateUsers() {
  try {
    const res = await fetchClient.get<ApiResponse<Affiliate[]>>('/affiliate')
    return res.data.data
  } catch (error) {
    throw error
  }
}

export async function sendEmailAffReq(data: string) {
  const payload = { data }
  try {
    const res = await fetchClient.post(`/sendEmail`, payload)
    return res.data
  } catch (err) {
    throw err
  }
}

export async function getAffiliateUserData(affId: string) {
  const res = await fetchClient.get<ApiResponse<AffUserData>>(`/affiliate/${affId}`)
  return res.data.data
}
export async function createAffUser(data: Partial<Affiliate>) {
  const res = await fetchClient.post<ApiResponse<Affiliate>>('/affiliate', data)
  return res.data.data
}
export async function deleteAffiliate(id: string) {
  const res = await fetchClient.delete(`/affiliate/${id}`)
  return res.data
}

export async function getCouponByAffUserId(refUserId: string): Promise<Coupon[]> {
  try {
    const res = await fetchClient.post(`/coupons/byrefuserid`, { id: refUserId })
    return res.data.data
  } catch (error) {
    throw error
  }
}
export async function updateAffUser(userId: string, data: UpdateAffiliatePayload) {
  const res = await fetchClient.patch(`/affiliate/${userId}`, data)
  return res.data
}

export async function createAffiliateLink(
  affiliateId: string,
  data: { code: string; name: string; description?: string }
): Promise<AffLink> {
  const res = await fetchClient.post<ApiResponse<AffLink>>(`/affiliate/${affiliateId}/links`, {
    ...data,
    affiliateId,
  })
  return res.data.data
}

export async function deleteAffiliateLink(code: string): Promise<void> {
  await fetchClient.delete(`/affiliate/links/${encodeURIComponent(code)}`)
}
